import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { navTypes } from './navTypes';

@Component({
  selector: 'takeoff-group-right-nav',
  templateUrl: './right-nav.component.html',
  styleUrls: ['./right-nav.component.css']
})
export class RightNavComponent implements OnInit {
  @Input() navType;
  @Input() show: boolean;
  @Input('nav-title') navTitle: string;
  @Output() onClose = new EventEmitter<boolean>();
  navTypeEnum = navTypes;
  constructor() { }

  ngOnInit() {
  }

  handleClose(){
    this.onClose.emit(false);
  }

  ngOnChanges() {
    this.show = this.show;
  }
}
